var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdetailHR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.4,
    height: 12,
    viewBox: "0 0 7.4 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_-_chevron_-_left",
    "data-name": "icon - chevron - left",
    transform: "translate(7.4 12) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2804",
    "data-name": "Group 2804",
    transform: "translate(210.554 -427.557) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M311.1,876.4l-4.6,4.6,4.6,4.6-1.4,1.4-6-6,6-6Z",
    transform: "translate(-447.443 514.254) rotate(-90)",
    fill: "#203662"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdetailHR);
export default __webpack_public_path__ + "static/media/edetail-h-r.f45068de5b1c76f4e53b7cd265a82343.svg";
export { ForwardRef as ReactComponent };